import {
  clearAuth,
  getAccessToken,
  getRefreshToken,
  getTenantId,
  setToken,
} from "./auth";

const axios = require("axios").default;

// 后端地址：开发 .env.development / 生产 .env.production 的 VUE_APP_BASE_URL
const BASE_URL = process.env.VUE_APP_BASE_URL || "https://hb.api.zhthep.com";
// const BASE_URL = process.env.VUE_APP_BASE_URL || "http://223.83.120.14:1163";
// const BASE_URL = process.env.VUE_APP_BASE_URL || "localhost:48080";
const API_URL = BASE_URL + "/admin-api";

const request = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// 携带登录令牌与租户编号，后端据此按租户过滤数据
request.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  const tenantId = getTenantId();
  if (tenantId) {
    config.headers["tenant-id"] = tenantId;
  }
  return config;
});

const toLogin = () => {
  clearAuth();
  const current = window.location.pathname + window.location.search;
  if (window.location.pathname !== "/login") {
    window.location.href = "/login?redirect=" + encodeURIComponent(current);
  }
};

// 并发 401 时共用一次刷新
let refreshing = null;
const refreshAccessToken = () => {
  if (!refreshing) {
    const refreshToken = getRefreshToken();
    refreshing = (refreshToken
      ? axios.post(
          API_URL + "/system/auth/refresh-token",
          null,
          {
            params: { refreshToken },
            headers: getTenantId() ? { "tenant-id": getTenantId() } : {},
          }
        )
      : Promise.reject(new Error("no refresh token"))
    )
      .then((res) => {
        if (res.data && res.data.code === 0 && res.data.data) {
          setToken(res.data.data);
          return;
        }
        throw new Error((res.data && res.data.msg) || "刷新令牌失败");
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
};

// 保持返回 axios 原始响应（页面按 res.status / res.data.code 判断）；仅拦截未登录
request.interceptors.response.use((res) => {
  if (!res.data || res.data.code !== 401) {
    return res;
  }
  const config = res.config;
  if (config._retried) {
    toLogin();
    return Promise.reject(new Error("未登录"));
  }
  return refreshAccessToken()
    .then(() => {
      config._retried = true;
      config.headers.Authorization = "Bearer " + getAccessToken();
      return request(config);
    })
    .catch(() => {
      toLogin();
      return Promise.reject(new Error("登录已过期"));
    });
});

// 复用 PC 端登录接口
export const login = (data) => {
  return axios.post(API_URL + "/system/auth/login", data, { timeout: 30000 });
};

// 退出登录（服务端注销令牌）
export const logout = () => {
  return request.post("/system/auth/logout");
};

// 登录用户信息：systemTitle 为租户配置的平台标题，与 PC 端顶部标题同源
export const getPermissionInfo = () => {
  return request.get("/system/auth/get-permission-info");
};

export { axios };
export default request;
